import React from "react";
import { navSections, partnerNames } from "../../data/site";
export function SiteFooter() {
  return <footer className="bg-sun pt-20 text-ink" data-id="element-639" data-mp="2tlne2dsqp8p6">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-640" data-mp="2tju2ql76m0au">
        <div className="grid gap-10 md:grid-cols-[1fr_auto]" data-id="element-641" data-mp="2olsocdkpap5p">
          <div data-id="element-642" data-mp="2klih6xl69sp9">
            <p className="text-[12px] font-bold uppercase tracking-wide" data-id="element-643" data-mp="2klrzdyzz6vke">In partnership with</p>
            <ul className="mt-3 space-y-1" data-id="element-644" data-mp="2fmnpf6588tt0">
              {partnerNames.map(p => <li key={p} className="font-display text-3xl uppercase md:text-4xl" data-id="element-645" data-mp="2avp4ft9an7jf">
                  {p}
                </li>)}
            </ul>
          </div>
          <nav aria-label="Footer" className="flex flex-wrap gap-2 self-end" data-id="element-646" data-mp="25tzsmbe8ypua">
            {navSections.map(s => <a key={s.id} href={`#${s.id}`} className="rounded-full border border-ink px-4 py-2 text-[12px] font-semibold uppercase tracking-wide transition-colors duration-150 hover:bg-ink hover:text-sun" data-id="element-647" data-mp="1wvedyrbwbuys">
                {s.label}
              </a>)}
          </nav>
        </div>
        {/* Sized so "EE Challenge" always fits on one line. */}
        <p className="mt-16 select-none whitespace-nowrap text-center font-display text-[clamp(3rem,12.5vw,12rem)] uppercase leading-[0.85]" aria-hidden="true" data-id="element-648" data-mp="2q9l5fcpt1wpb">
          EE Challenge
        </p>
        <p className="border-t border-ink/25 py-5 text-center text-[12px] font-semibold uppercase tracking-wide" data-id="element-649" data-mp="3i0hh4a04pvb0">
          Engineering Entrepreneurship Challenge · October 2026
        </p>
      </div>
    </footer>;
}